import { flatState } from './flat-slate';
import { futuroDark } from './futuro-dark';
import { standard } from './standard';
import { Theme } from '../../../utilities/theme';
import { futuro } from './futuro';
import { lozengeInput } from './lozenge-input';

export const getTheme = (theme: Theme | 'lozenge-input') => {
  switch (theme) {
    case 'nova':
    case 'standard':
      return standard;
    case 'futuro':
      return futuro;
    case 'futuro-dark':
      return futuroDark;
    case 'flat-slate':
      return flatState;
    case 'lozenge-input':
      return lozengeInput;
    default:
      return standard;
  }
};
